import React from "react";
import { Button } from "react-bootstrap";

import { useTranslation } from "react-i18next";

export default function RefreshButton({ refresh, disabled }) {
  const {
    t,
  } = useTranslation();

  return (
    <div className="float-right">
      <Button onClick={refresh} variant="success" size="md" className="btn-outline pb-1 pl-2 pr-2 m-0" title={t("common.actions.refresh")}>
        {disabled ? (
          <div>
            <i className="nc-icon nc-refresh-02 icon-bold fa-spin"></i>
          </div>
        ) : (
          <div>
            <i className="nc-icon nc-refresh-02 icon-bold" />
          </div>
        )}
      </Button>
    </div>
  );
}
